import { render, staticRenderFns } from "./ListingDashboard.vue?vue&type=template&id=22bb6d5c&"
import script from "./ListingDashboard.vue?vue&type=script&lang=js&"
export * from "./ListingDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ListingDashboard.vue?vue&type=style&index=0&id=22bb6d5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports